import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Article } from '../../model/article';


@Injectable()
export class PublicationService {


  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
  ) { }


  activePublicationProvider(idpub: number, publish: boolean){

    const body=  {
      /* titre: page.titre,
      description: page.description,
      slug: page.slug,
      isPublish: page.is_publish,
      datePublish: page.date_publish,
      photoSelected: page.photo,
      shortTitle: page.short_title,
      parent: page.idparent,
      videoYoutube: page.video_youtube,
      fichierSelected: page.fichier, */
               
     };
     
     var donnees = JSON.stringify(body);

     
     return this.http.patch(this.apiEndpoints.GET_URL_ACTIVATE_PUBLICATION(idpub, publish), donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  
    }




}
